// import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { tableConfigs } from "../../Utils/Functions/Table_Configs";
import { useRef, useLayoutEffect, useMemo } from "react"

const DatasheetMultichoice = ({ focus, rowData, setRowData, columnData, active, stopEditing }) => {

    const {tableName, fieldName} = columnData;
    const field = useMemo(() => tableConfigs[tableName].fields.find(field => field.label === fieldName), [tableName, fieldName]);
    const options = useMemo(() => field.options.map(option => ({label: option, value: option})), [field]);
    
    const selectRef = useRef(null)

    useLayoutEffect(() => {
        if (focus) {
            selectRef.current?.focus()
        } else {
            selectRef.current?.blur()
        }
    }, [focus])

    return (

        <Select
            ref={selectRef}
            isClearable
            menuIsOpen={focus}
            menuPortalTarget={document.body}
            onChange={(value) => {
                setRowData(value?.value ?? "");
                setTimeout(() => stopEditing({nextRow: false}), 0)
            }}
            onMenuClose={() => stopEditing({nextRow: false})}
            options={options}
            
            value={options?.find(({value}) => value === rowData) ?? null}
            styles={{
                container: (provided) => ({
                    ...provided,
                    flex: 1, // full width
                    alignSelf: 'stretch', // full height
                    pointerEvents: focus ? undefined : 'none',
                }),
                control: (provided) => ({
                    ...provided,
                    height: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    background: 'none',
                }),
                indicatorsContainer: (provided) => ({
                    ...provided,
                    opacity: active ? 1 : 0,
                }),
                placeholder: (provided) => ({
                    ...provided,
                    opacity: active ? 1 : 0,
                }),
            }}
        />
    )
}

const multichoiceColumn = ({title, tableName, fieldName}) => ({
    component: DatasheetMultichoice,
    columnData: {tableName, fieldName},
    disableKeys: true,
    deleteValue: () => null,
    title,
    minWidth: 200,
    copyValue: ({ rowData }) => rowData,
    pasteValue: ({ value }) => value,
})

export default multichoiceColumn